document.addEventListener("DOMContentLoaded", function () {
  function waitForElement(selector, callback) {
    const element = document.querySelector(selector);
    if (element) {
      callback(element);
    } else {
      let checks = 0;
      const interval = setInterval(() => {
        const el = document.querySelector(selector);
        if (el || checks > 20) {
          clearInterval(interval);
          if (el) callback(el);
        }
        checks++;
      }, 100);
    }
  }

  waitForElement("#quote-popup", function () {
    const popup = document.getElementById("quote-popup");
    const content = document.getElementById("quote-popup-content");

    const preventBodyScroll = () => document.body.style.overflow = "hidden";
    const restoreBodyScroll = () => document.body.style.overflow = "";
    
    const closePopup = () => {
      popup.style.display = "none";
      restoreBodyScroll();
    };

    const showPopup = () => {
      popup.style.display = "block";
      preventBodyScroll();
    };

    const calculateCartTotal = (cart) => {
      let cartTotal = 0;
      let hasPendingQuote = false;
      
      cart.forEach(item => {
        const unitPrice = parseFloat(item.price) / 100;
        if (item.formatted_price === "$0.00" || unitPrice === 0) {
          hasPendingQuote = true;
        } else {
          cartTotal += unitPrice * item.quantity;
        }
      });

      return hasPendingQuote ? "Pending Quote" : cartTotal.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    };

    const escapeHtml = (value) => {
      if (value === null || value === undefined) return "";
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    };

    // Allow only <sub> and <sup> in displayed titles. Everything else stays escaped.
    const sanitizeTitleHtml = (value) => {
      const escaped = escapeHtml(value);
      return escaped
        .replace(/&lt;sub&gt;/gi, "<sub>")
        .replace(/&lt;\/sub&gt;/gi, "</sub>")
        .replace(/&lt;sup&gt;/gi, "<sup>")
        .replace(/&lt;\/sup&gt;/gi, "</sup>");
    };

    const generateCartItemHTML = (item) => {
      const itemUnitPrice = parseFloat(item.price) / 100;
      const isPendingQuote = item.formatted_price === "$0.00" || itemUnitPrice === 0;
      const displayedItemTotal = isPendingQuote ? "Pending Quote" : `${(itemUnitPrice * item.quantity).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      })}`;
      const safeTitle = escapeHtml(item.product_title);
      const displayTitle = sanitizeTitleHtml(item.product_title);
      
      return `
        <div class="quote-cart-item" data-variant-id="${item.variant_id}">
          <div class="quote-cart-item-details">
            <div class="quote-cart-item-image">
              <img src="${item.image}" alt="${safeTitle}" style="width: 65px; height: 65px;" />
            </div>
            <div class="quote-popup-details-ts">
              <div class="quote-cart-item-title">
                ${displayTitle}
              </div>
              <div class="quote-cart-item-price" style="padding:0 1rem; color: #666; font-size: 14px;">
                ${displayedItemTotal}
              </div>
            </div>
          </div>
          <div class="quote-cart-quantity">
            <div class="quote-quantity-buttons">
              <button type="button" class="quote-qty-decrement" data-action="decrease" data-variant-id="${item.variant_id}">-</button>
              <input type="text" pattern="\d*" inputmode="numeric" class="quote-cart-qty" value="${item.quantity}" min="1" data-variant-id="${item.variant_id}" data-previous-value="${item.quantity}" />
              <button type="button" class="quote-qty-increment" data-action="increase" data-variant-id="${item.variant_id}">+</button>
            </div>
            <div class="quote-quantity-remove">
              <button class="remove-quote-item" style="font-size: 13px;" data-variant-id="${item.variant_id}" data-action="remove">Remove</button>
            </div>
          </div>
        </div>
      `;
    };

    const showEmptyCart = () => {
      content.innerHTML = `
        <div class="quote-cart-summary">
          <div class="quote-cart-empty">
            <img src="${window.themeAssets?.emptyQuoteCart}" alt="Empty Quote Cart" style="max-width: 200px; margin: 2rem auto; display: block;" />
            <div style="color: #6A6A6A; font-size: 24px; font-weight: 500;">Quote Cart is Empty</div>
          </div>
        </div>
      `;
    };

    const showCartWithItems = (cart) => {
      const cartItemsHTML = cart.map(generateCartItemHTML).join('');
      const displayedCartTotal = calculateCartTotal(cart);

      content.innerHTML = `
        <div class="quote-cart-summary">
          <div class="quote-cart-items">
            ${cartItemsHTML}
          </div>
          
          <div class="quote-cart-details">
            <div class="quote-cart-subtotal">
              <h5>Total</h5>
              <h5 class="quote-cart-total">${displayedCartTotal}</h5>
            </div>

            <div class="quote-cart-buttons">
              <button type="button" class="quote-proceed-btn" style="cursor: pointer; pointer-events: auto; position: relative; z-index: 1000;">
                REQUEST A QUOTE
              </button>
            </div>
          </div>
        </div>
      `;
      
      // Attach event listener directly to the button after it's created
      setTimeout(() => {
        const proceedBtn = content.querySelector(".quote-proceed-btn");
        if (proceedBtn) {
          proceedBtn.addEventListener("click", (btnEvent) => {
            console.log("Direct button click detected!");
            btnEvent.preventDefault();
            btnEvent.stopPropagation();
            closePopup();
            window.location.href = "/pages/quote-request";
          });
        }
      }, 100);
    };

    const updatePopupContent = (cart) => {
      if (cart.length === 0) {
        showEmptyCart();
      } else {
        showCartWithItems(cart);
      }
    };

    // Event handlers using event delegation (attached once, works for all dynamically created elements)
    popup.addEventListener("click", (event) => {
      // Click outside content area to close (only if clicking directly on popup background)
      if (event.target === popup) {
        console.log("Clicked outside - closing popup");
        closePopup();
      }
    });

    const closeBtn = popup.querySelector(".quote-close-btn");
    if (closeBtn) {
      closeBtn.addEventListener("click", (btnEvent) => { // Handle close button
        btnEvent.stopPropagation();
        btnEvent.preventDefault();
        closePopup();
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.target.classList.contains('quote-cart-qty')) {
        const input = event.target;
        const isDigit = /^[0-9]$/.test(event.key);
        const isAllowedKey = ['Backspace', 'Delete', 'Tab', 'Escape', 'ArrowRight', 'ArrowLeft'].includes(event.key);
        if (event.key === 'Enter') {
          input.blur();
        } else if (!isDigit && !isAllowedKey) {
          event.preventDefault();
        }
      }
    });

    popup.addEventListener("blur", (event) => {
      if (event.target.classList.contains("quote-cart-qty")) {
        const input = event.target;
        let currentValue = parseInt(input.value);
        
        if (isNaN(currentValue) || currentValue < 1) {
          const previousValue = parseInt(input.dataset.previousValue) || 1;
          input.value = previousValue;
        }
      }
    }, true);

    // Main event listener for showing quote popup
    window.addEventListener("showQuotePopup", function (e) {
      const submittedQuoteCart = sessionStorage.getItem("submittedQuoteCart");
      if (submittedQuoteCart) {
        sessionStorage.removeItem("submittedQuoteCart");
      }
      const product = e.detail;
      
      let quoteCart = JSON.parse(sessionStorage.getItem("quoteCart") || "[]");
      let cartItem = quoteCart.find(item => item.variant_id === product.variant_id);

      if (!cartItem && product) {
        cartItem = { ...product, quantity: product.quantity || 1 };
        quoteCart.push(cartItem);
        sessionStorage.setItem("quoteCart", JSON.stringify(quoteCart));
      }

      updatePopupContent(quoteCart);
      showPopup();
    });

    window.addEventListener('quoteCartChanged', (e) => {
      const currentCart = e.detail.cart;
      updatePopupContent(currentCart);
      
      // Do we want to close popup if cart becomes empty
      // if (currentCart.length === 0) {
      //   closePopup();
      // }
    });

    window.quotePopupUtils = {
      updateCartTotal: () => {
        const currentCart = JSON.parse(sessionStorage.getItem("quoteCart") || "[]");
        const displayedCartTotal = calculateCartTotal(currentCart);
        const totalEl = content.querySelector(".quote-cart-total");
        const totalHeader = content.querySelector(".quote-cart-subtotal h5:first-child");
        
        if (totalEl) {
          totalEl.textContent = displayedCartTotal;
        }
        if (totalHeader) {
          totalHeader.textContent = "Total";
        }
        
        console.log("Cart total updated:", displayedCartTotal, "Items:", currentCart.length);
      },

      saveQuantityToSession: (variantId, qty) => {
        if (window.quoteCartManager) {
          window.quoteCartManager.updateQuantity(variantId, qty);
        } else {
          let currentCart = JSON.parse(sessionStorage.getItem("quoteCart") || "[]");
          let itemIndex = currentCart.findIndex(item => item.variant_id == variantId);
          if (itemIndex !== -1) {
            currentCart[itemIndex].quantity = qty;
            sessionStorage.setItem("quoteCart", JSON.stringify(currentCart));
            console.log("Updated cart:", currentCart);
          } else {
            console.error("Item not found in cart for variant ID:", variantId);
          }
        }
      },

      removeItemFromSession: (variantId) => {
        if (window.quoteCartManager) {
          window.quoteCartManager.removeFromCart(variantId);
          return window.quoteCartManager.getCart();
        } else {
          let currentCart = JSON.parse(sessionStorage.getItem("quoteCart") || "[]");
          currentCart = currentCart.filter(item => item.variant_id !== variantId);
          sessionStorage.setItem("quoteCart", JSON.stringify(currentCart));
          return currentCart;
        }
      }
    };
  });
});
